import React, { memo } from "react";
import Input from "./Input";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

type Props = {
  name?: string;
  value?: string;
  placeHolder?: string;
  onClickSuffix?: () => void;
  handleOnChange: (
    fieldName: string,
    fieldValue: string,
    isValid?: boolean | true
  ) => void;
  autoFocus?: boolean;
  listLogic?: boolean;
  suffixIcon?: string;
  handleEnter?: () => void;
};

const SearchInput: React.FC<Props> = ({
  name = "search-country-code",
  placeHolder = "search_country_code",
  value = "",
  onClickSuffix,
  handleOnChange,
  autoFocus = false,
  listLogic = false,
  suffixIcon = "close",
  handleEnter,
}) => {
  return (
    <div className="search-group">
      <Input
        type="search-input"
        className="pt-0"
        name={name}
        handleOnChange={handleOnChange}
        value={value}
        placeHolder={placeHolder}
        prefixType="icon"
        prefixIcon="search"
        suffixType={
          listLogic ? "icon" : UtilityHelper.isNotEmpty(value) ? "icon" : ""
        }
        suffixIcon={suffixIcon}
        suffixHandleClick={onClickSuffix}
        autoFocus={autoFocus}
        handleEnter={handleEnter}
      />
    </div>
  );
};

export default memo(SearchInput);
